import styled from 'styled-components'

import { FlexContainer, Container } from '../../styles/defaults'
import { minmedia, maxmedia } from '../../styles/media-queries'
import { bordergray } from '../../styles/colors'
import { Container as SearchInput } from '../../components/SearchInput/styles'

export const PageTitle = styled.h1`
  margin: 0;
  font-weight: 400;
  font-size: 22px;
  margin-bottom: 1.5rem;
  ${maxmedia.medium`
    text-align: center;
    width: 100%;
  `};
  ${minmedia.large`
    font-size: 30px;
  `};
`

export const MiniContainer = Container.extend`
  width: 1000px;
  margin-top: 6rem;
`

// Info
export const InfoContainer = FlexContainer.extend`
  align-items: center;
  margin-bottom: 1rem;
  border-top: 1px solid ${bordergray};
  border-bottom: 1px solid ${bordergray};

  ${minmedia.medium`
    margin-bottom: 1.5rem;
    padding: 1rem 4%;
  `} ${minmedia.large`
    margin-bottom: 2rem;
    padding: 1rem 0;
  `};
`

export const CompanyInfo = styled.div`
  width: 100%;
  padding: 1rem 4%;
  padding-bottom: 0;
  font-size: 16px;
  ${minmedia.medium`
    width: 50%;
    padding: 0; //reset
    font-size: 18px;
  `};
  ${minmedia.large`
    display: flex;
    flex-wrap: wrap;
  `};
`

export const SearchContainer = styled.div`
  width: 100%;
  padding: 1rem 4%;
  border-top: 1px solid ${bordergray};
  ${maxmedia.medium`
    border-top: 0;
  `};
  ${maxmedia.large`
    ${SearchInput} {
      width: 100%;
    }
  `};
  ${minmedia.medium`
    border: 0; //reset
    padding: 0; //reset
    width: 50%;

    ${SearchInput} {
      margin-left: auto; //align right
    }
  `};
`


// WEBPACK FOOTER //
// ./src/views/Documents/styles.js